import { moment } from "@msuite/utils/date";
import { type RefObject, useRef } from "react";
import { cn } from "../utils";
import { CalendarDayContentInlay } from "./calendar-day-content-inlay";
import { CalendarItem } from "./calendar-item";
import {
	CALENDAR_DAY_HOURS,
	CALENDAR_DAY_STEP_FACTOR,
	CALENDAR_HOUR_HEIGHT,
	type CalendarDayBaseProps,
} from "./shared";

/** Props Interface */
interface CalendarDayContentProps<T extends object = object> extends CalendarDayBaseProps<T> {}

const gridTemplateRows = `repeat(${CALENDAR_DAY_HOURS}, ${CALENDAR_HOUR_HEIGHT}px)`;
const gridTemplateRowsInlay = `repeat(${CALENDAR_DAY_HOURS * CALENDAR_DAY_STEP_FACTOR}, ${CALENDAR_HOUR_HEIGHT / CALENDAR_DAY_STEP_FACTOR}px)`;

export function CalendarDayContent({ item }: CalendarDayContentProps) {
	/** Computed */
	const isWeekend = moment(item.date).isWeekend();
	const containerRef = useRef<HTMLDivElement>(null) as RefObject<HTMLDivElement>;

	/** Render */
	return (
		<div
			className={cn("h-full w-full grid relative z-0", isWeekend ? "stripes" : "card-bg")}
			style={{ gridTemplateRows }}
			ref={containerRef}
		>
			<CalendarDayContentInlay />
			<div
				className="absolute inset-0 z-0 grid px-1"
				style={{
					gridTemplateRows: gridTemplateRowsInlay,
					gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))",
				}}
			>
				{item.items
					.filter((item) => item.durationType === "timed")
					.map((calendarItem) => (
						<CalendarItem
							key={calendarItem.id}
							item={calendarItem}
							date={item.date}
						/>
					))}
			</div>
		</div>
	);
}
